<template>
  <div class='EnbContas'>
    <cont-actions>
      <adm-search place="email" @run="newValue => search(newValue)"/>
      <adm-btn text="Ativar" @click="_UpdateContas(true)"/>
      <adm-btn text="Desativar" color="red" @click="_UpdateContas(false)"/>
      <adm-btn text="Ativar log" color="green" @click="_UpdateContasLog(true)"/>
      <adm-btn text="Desativar log" color="red" @click="_UpdateContasLog(false)"/>
    </cont-actions>
    <adm-header
    :headers="headers"
    :list="data"
    @toggle="newValue => newValue ? ListItemSelectedPush(data) : ListItemSelectedDel(data)"
    />
    <div class="cont-contas">
      <list-item
      v-for="(d, key) in data"
      :key="key"
      :chave="key"
      :headers="headers_data"
      :data="d"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ContActions from '../topActions/ContActions'
import AdmHeader from '../header/AdmHeader'
import ListItem from '../ListItem'
import AdmSearch from '../topActions/AdmSearch'
import AdmBtn from '../topActions/AdmBtn'
export default {
  name: 'EnbContas',
  components: { ContActions, AdmHeader, ListItem, AdmSearch, AdmBtn },
  data () {
    return {
      headers: [
        { text: 'id', width: '5%' },
        { text: 'email', width: '25%' },
        { text: 'empresa', width: '20%' },
        { text: 'subdomínio', width: '20%' },
        { text: 'modelo', width: '10%' },
        { text: 'status', width: '10%' },
        { text: 'log', width: '10%' }
      ],
      headers_data: [
        { chave: 'id', width: '5%' },
        { chave: 'email', width: '25%' },
        { chave: 'nome_empresa', width: '20%' },
        { chave: 'subdominio', width: '20%' },
        { chave: 'modelo', width: '10%' },
        { chave: 'status', width: '10%' },
        { chave: 'statusLog', width: '10%' }
      ],
      data: []
    }
  },
  methods: {
    ...mapActions(['GetContas', 'ListItemSelectedPush', 'ListItemSelectedDel', '_UpdateContas', '_UpdateContasLog']),
    search (email) {
       this.GetContas(email)
         .then(res => this.data = res)
    }
  },
  created () {
    this.GetContas('')
      .then(res => {
        this.data = res
      })
  }
}
</script>

<style scoped>
/* altura da tela menos o AdmTop (40px); a lista ocupa o que sobra abaixo das ações e do cabeçalho */
.EnbContas {
  width: 100%;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;
}
.cont-contas{
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
